export const POLICY_AGREEMENTS = {
  TERMS_OF_USE: 'Terms of use',
  PRIVACY_POLICY: 'Privacy Policy',
  EFTA: 'EFTA',
  DISCLOSURE: 'Disclosure',
  SECONDARY_LISTING_AGREEMENT: 'Secondary Listing Agreement',
  AFFILIATE_AGREEMENT: 'Referral Agreement',
  SMS_COMMUNICATION: 'SMS Communications Policy'
};

export const POLICY_AGREEMENTS_TITLE = {
  TERMS_OF_USE: 'Realbricks Terms and Conditions',
  PRIVACY_POLICY: 'Realbricks Privacy Policy',
  EFTA: 'Electronic Funds Transfers Agreement and Disclosure',
  DISCLOSURE: 'Regulation A Investment Disclosure',
  SECONDARY_LISTING_AGREEMENT: 'Secondary Listing Agreement',
};

export const POLICY_ENUMS = [POLICY_AGREEMENTS.PRIVACY_POLICY, POLICY_AGREEMENTS.TERMS_OF_USE, POLICY_AGREEMENTS.SECONDARY_LISTING_AGREEMENT];

export const AGREEMENT_ACCEPTANCES = {
  AGREE_SUBSCRIPTION_AGREEMENT: 'I have read and understand the above Subscription Agreement.',
};
